// extracted by mini-css-extract-plugin
export default {"label":"style_label__IlKHK","buttons":"style_buttons__MO9Px"};